import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson37: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[7.63rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson36"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Calories</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson38"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[9.63rem] max-w-[125rem] text-justify text-[1.88rem] text-white font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>
                How Many Calories Should You Eat Per Day to Lose Weight?
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Your ideal calorie intake depends on things like age and
                activity level. Most cisgender females need at least 1,600 daily
                calories to maintain their weight, while cisgender males need at
                least 2,000. If you want to lose weight, eating less can help.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Reducing the number of calories you eat per day can be an
                effective weight loss method.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                However, figuring out exactly how many calories you should eat
                can be tricky, as it depends on a variety of factors, including
                your age, sex, size, and activity level.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Below is a simple scientific calorie calculator, along with five
                evidence-based tips on how to sustainably reduce your calorie
                intake.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>How Many Calories Should You Eat?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                When trying to lose weight, it’s important to create a calorie
                deficit by consuming fewer calories than you normally do or by
                exercising more. Some people choose to combine the two, eating a
                little less while being more physically active.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Still, it’s important to ensure that you’re consuming enough
                nutrients, even if you’re trying to lose weight, or you risk
                developing nutritional deficiencies and metabolic changes that
                make long-term weight maintenance difficult.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Here’s a closer look at how many calories you should eat based
                on recommendations from the U.S. Department of Agriculture’s
                (USDA’s) 2020–2025 Dietary Guidelines for Americans.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Females Assigned at Birth (FAABs)</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Keep in mind that these estimates don’t apply to those who are
                pregnant or breastfeeding, as they’ll need significantly more
                calories.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[13rem] object-cover"
          alt=""
          src="/221@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Males Assigned at Birth (MAABs)</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Men who are very active or have certain health conditions may
                require more calories. The number you need within these ranges
                also varies based on your height and weight.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[13rem] object-cover"
          alt=""
          src="/222@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">Children</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Keep in mind that cutting a child’s calorie intake may
                  increase their risk of nutritional deficiencies, slow growth,
                  and foster an unhealthy relationship with food or an eating
                  disorder (
                </span>
              </span>
            </span>
            <a
              className="text-[inherit]"
              href="https://pubmed.ncbi.nlm.nih.gov/27550979/"
              target="_blank"
            >
              <span>
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      8Trusted Source
                    </span>
                  </span>
                </span>
              </span>
            </a>
            <span>
              <span>
                <span>
                  ). Instead of counting calories, it’s best to encourage eating
                  healthy, nutrient-dense foods.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span className="font-dm-sans">&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span className="font-dm-sans">
                  The amount of calories that your body needs can vary depending
                  on your age, sex, activity level, and body size.
                </span>
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[24.25rem] object-cover"
          alt=""
          src="/223@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>What Are Calories?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Simply put, a calorie is a unit that measures energy. Calories
                  are usually used to measure the energy content of foods and
                  beverages.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  To lose weight, you need to eat fewer calories than your body
                  burns each day. Conversely, to gain weight, you need to
                  consume more calories than you expend.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Keep in mind that while the “calories in, calories out”
                  concept of weight loss may seem simple, many factors
                  contribute to weight loss or the inability to lose weight,
                  including medical diagnoses, hormonal changes, genetics, and
                  age (9Trusted Source).
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Calories are units that measure the energy content of foods
                  and beverages. While many factors can influence weight loss,
                  you generally need to eat fewer calories than you burn to lose
                  weight.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Reducing Calorie Intake</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Although decreasing the number of calories you consume can be
                effective for weight loss, cutting calories without considering
                which foods you eat isn’t a sustainable way to lose weight.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Here are five simple strategies that may help you lose weight.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <ul className="m-0 text-[1.5rem] pl-[2.5rem] text-white">
            <li className="mb-[0rem]">
              <b>Eat More Protein</b>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            When it comes to losing weight, protein is incredibly important.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Studies show that increasing your intake of protein may help keep
            you full and curb your appetite.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Protein may also help fight cravings. According to some research,
            high protein snacks help enhance feelings of fullness while
            decreasing hunger and appetite.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            In addition to promoting weight loss, some research suggests that
            maintaining a high protein diet may prevent or reduce weight regain
            and help maintain muscle mass.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Therefore, if you want to achieve long lasting, sustainable weight
            loss, consider increasing your protein intake by eating more eggs,
            meat, poultry, tofu, nuts, seeds, or legumes.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <ul className="m-0 text-[1.5rem] pl-[2.5rem] text-orangered-200">
            <li className="mb-[0rem]">
              <b>Limit Sugary Drinks</b>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Another relatively easy change you can make is to limit your intake
            of sugar-sweetened beverages, including sodas, fruit juices,
            chocolate milk, and other drinks with added sugar.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Your brain doesn’t register liquid calories the same way it does
            solid calories, so they affect your feelings of hunger and fullness
            less significantly.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Additionally, studies associate drinking sugary beverages with an
            increased risk of obesity.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The harmful effects of sugar also go far beyond weight gain. In
            fact, added sugar may contribute to other health issues, including
            heart disease, liver problems, and type 2 diabetes.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <ul className="m-0 text-[1.5rem] pl-[2.5rem] text-white">
            <li className="mb-[0rem]">
              <b>Drink More Water</b>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            One simple thing you can do for your health is to drink more water.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Adequate hydration is associated with improved brain health and
            weight management, as well as a reduced kidney stone risk.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            What’s more, drinking water immediately before meals may reduce
            hunger and help you eat fewer calories.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            When combined with a healthy diet, drinking more water — especially
            before meals — appears to be helpful if you need to lose weight.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <ul className="m-0 text-[1.5rem] pl-[2.5rem] text-white">
            <li className="mb-[0rem]">
              <b>Exercise</b>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Resistance-training activities like weightlifting have been shown to
            limit muscle loss, which may help minimize metabolic changes during
            long-term calorie restriction.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Cardio exercises, such as walking, swimming, or jogging, are also
            important — both for increasing weight loss and supporting overall
            health.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Additionally, exercise has a variety of other benefits that go
            beyond weight loss, such as increased longevity, enhanced energy
            levels, improved mental health, and a decreased risk of chronic
            disease.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1rem]">
          <ul className="m-0 pl-[2.5rem]">
            <li className="mb-[0rem]">
              <b>
                <span>Reduced Processed Foods</span>
              </b>
            </li>
          </ul>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  The term “refined carbs” refers to grains that have lost their
                  bran and germ, including white bread, pasta, crackers, and
                  white rice. It also includes sugar and other sweeteners.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Refined grains typically lack fiber, which supports weight
                  loss by decreasing your appetite and increasing feelings of
                  fullness.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Eating fewer refined carbs may promote weight loss by altering
                  levels of specific hormones that regulate your appetite, such
                  as peptide YY. It’s also best to avoid ultra-processed foods.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Eating more protein, exercising, staying hydrated, and
                  limiting your intake of refined carbs and sugary beverages are
                  a few simple ways to decrease your daily calorie intake.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>Counting Calories</b>
          </p>
          <p className="m-0 text-[1.56rem] text-gainsboro-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Although counting calories can be an effective strategy for
                weight loss, it’s important to remember that there are many
                other factors to consider when choosing what and how to eat.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Instead of focusing solely on calories, it’s best to follow a
                balanced diet that’s rich in a variety of nutritious, whole
                foods.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                If you do decide to cut calories, be careful not to decrease
                your intake too much, as doing so may cause several serious side
                effects.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Research shows that young adults who use calorie-tracking apps
                to monitor how many calories they consume may be more at risk
                for developing disordered eating patterns that could develop
                into eating disorders.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                That said, for people who are not at risk for developing
                disordered eating habits, restricting how much you eat can be a
                successful weight loss strategy, at least in the short term.
                However, eating too few calories may also slow your metabolism,
                making it harder to maintain weight loss in the long term.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>SUMMARY</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Cutting calories too much may harm your health and make it
                harder to maintain weight loss. Instead of focusing only on
                calories, concentrate on a well-rounded diet that’s rich in
                nutritious, whole foods.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Frequently Asked Question</b>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            <b>Are 1200 Calories Enough For a Day?</b>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Although it may help you lose weight, eating 1200 calories or
                less a day does not provide enough energy or nutrients for most
                healthy adults.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-orangered-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-[1.88rem] text-white">
            <b>How Many Calories Should You Eat For Breakfast?</b>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The number of calories that you should eat for breakfast depends
                on many factors, including your daily needs, personal
                preferences, health goals, and overall diet.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-orangered-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-[1.88rem] text-white">
            <b>How Many Calories Should You Eat For Lunch or Dinner?</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            While some people may enjoy eating a large lunch and smaller dinner,
            others may decide to distribute their calorie intake more evenly.
            Therefore, everyone’s needs and preferences are different.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0 text-[1.88rem] text-white">
            <b>How Many Calories Should You Eat to Gain Muscle?</b>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                To gain muscle, you may have to increase your calorie needs by a
                few hundred calories per day. A sports dietitian can help you
                develop an appropriate plan.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>SUMMARY</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The number of calories that you should eat at each meal or to
                reach a specific weight goal can differ. Therefore, it’s best to
                experiment to find what suits your needs.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans text-white">Takeaway</b>
          </p>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <p className="m-0">
            <span>
              How many calories you need per day depends on whether you want to
              maintain, lose, or gain weight, as well as various other factors,
              such as your sex, age, height, current weight, activity level, and
              metabolic health.
            </span>
          </p>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <p className="m-0">
            <span>
              {`Many websites and apps can help you track your calorie intake. You can try using a calorie counter or tracker for at least a few days to see the amount of calories, carbs, protein, fat, `}
            </span>
            <a
              className="text-[inherit]"
              href="https://www.healthline.com/nutrition/why-is-fiber-good-for-you"
              target="_blank"
            >
              <span>
                <span className="[text-decoration:underline]">fiber</span>
              </span>
            </a>
            <span>, vitamins, and minerals you’re eating.</span>
          </p>
          <p className="m-0">
            <span>&nbsp;</span>
          </p>
          <p className="m-0">
            <span>
              That said, working with a registered dietitian (RD) can also help
              you gain, maintain, or lose weight while ensuring that your
              nutrient needs are being met.
            </span>
          </p>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson38"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
      </div>
    </div>
  );
};

export default Lesson37;
